export const ROLES_MAP = new Map<number, string>();
ROLES_MAP.set(1, 'Amministratore');
ROLES_MAP.set(2, 'Proponente Responsabile');
ROLES_MAP.set(3, 'Collaboratore Proponente');
ROLES_MAP.set(4, "Regione");
ROLES_MAP.set(5, "Tecnico Capo");
ROLES_MAP.set(6, "Tecnico Base");
ROLES_MAP.set(7, "Segreteria");
ROLES_MAP.set(8, "Decretatore");
ROLES_MAP.set(9, "Membro CRPLF");
ROLES_MAP.set(99, "Accesso login");
ROLES_MAP.set(10, "Proponente");
ROLES_MAP.set(11, "Regione Tecnico");
ROLES_MAP.set(12, "Regione Amministratore");
ROLES_MAP.set(13, "Assistenza");
